<template>
  <button
    @click="toggleAvatar"
    :class="[custom]"
    class="group h-11 group rounded-full flex items-center relative cursor-pointer"
    :disable="disable"
  >
    <div class="open-user-menu w-10/5 h-10/5 rounded-full flex items-center justify-center transition-all duration-100">
      <base-icon
        :name="setArrow"
        :class="{ 'transform rotate-180': isOpen }"
        class="group-hover:text-primary transition-transform duration-300"
      />
    </div>
    <el-tooltip v-if="customText === ''" placement="top" :open-delay="750">
      <div slot="content">{{ user }}</div>
        <div class="user-name-div truncate hidden md:block">
        {{ user }}
      </div>
    </el-tooltip>
    <div v-else class="user-name-div truncate hidden md:block">
      {{ customText }}
    </div>
    <div v-if="showAvatar" class="w-10/5 h-10/5 bg-primary-700 rounded-full overflow-hidden flex items-center justify-center">
      <base-icon v-if="role === 3"
        name="avatarsa"
        size="lg"
        class="group-hover:text-primary text-secondary dark:text-darkblue-200 hover:bg-primary-50 dark:hover:bg-darkblue-600 hover:text-primary dark:hover:text-primary active:bg-primary-100 active:text-primary focus:bg-primary-100 focus:text-primary"
      />
      <base-icon v-else
        name="avatar"
        size="lg"
        class="group-hover:text-primary text-secondary dark:text-darkblue-200 hover:bg-primary-50 dark:hover:bg-darkblue-600 hover:text-primary dark:hover:text-primary active:bg-primary-100 active:text-primary focus:bg-primary-100 focus:text-primary"
      />
    </div>
    <div v-else class="w-10/5 h-10/5 bg-primary-700 rounded-full overflow-hidden"/>
  </button>
</template>

<script>
export default {
  name: 'base-avatar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [Array, String],
      default: ''
    },
    onMobile: {
      type: Boolean,
      default: false
    },
    customText: {
      type: String,
      default: ''
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {}
  },
  computed: {
    setArrow: function () {
      return this.onMobile ? 'chevronup' : 'chevrondown'
    },
    user: function () {
      const user = this.$store.getters['auth/user']
      if (user === null || user === undefined) return ''
      else return user.Usuario
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  methods: {
    toggleAvatar: function () {
      this.$emit('toggleAvatar')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-name-div {
  max-width: 200px;
}
</style>
